
import { Component, Vue } from 'vue-property-decorator';
import OsQuestionnairePage from '@/layouts/pages/OsQuestionnairePage.vue';
@Component({
  components: { OsQuestionnairePage }
})
export default class SurveyFinished extends Vue {}
